import { render, staticRenderFns } from "./CmgCountryFlag.vue?vue&type=template&id=61764964&scoped=true&lang=pug&"
import script from "./cmg-country-flag.ts?vue&type=script&lang=ts&"
export * from "./cmg-country-flag.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCountryFlag.vue?vue&type=style&index=0&id=61764964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61764964",
  null
  
)

export default component.exports